export const PostLayout = ({ title, content, handleBackClick, scrollToTop }) => {
    return (
        <div className="container">
            <button className="backButton" onClick={handleBackClick}>
                ← back
            </button>
            <h1 style={{ margin: "10px" }}>{title}</h1>
            <div className="innerContainer">{content}</div>

            <button className="backToTop" onClick={scrollToTop}>
                ↑ back to top
            </button>
        </div>
    );
};
